<div data-test-id="managed-privacy-policy-html"  [innerHtml]="html$ | async" [ngClass]="{ 'd-none': loading }"></div>

<div data-test-id="managed-privacy-policy-loading-wrapper"  class="py-5 d-flex justify-content-center align-items-center" *ngIf="loading">
  <mat-spinner data-test-id="managed-privacy-policy-spinner"  diameter="30"></mat-spinner>
</div>
